import { useEffect, useState, useMemo, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuid } from 'uuid'
import {
  BOX_COLORS,
  DEFAULT_AUTO_BET_COUNTER,
  DEFAULT_BET_AMOUNT,
  DEFAULT_MAX_PYRAMID_PLINKO_ROWS,
  DEFAULT_MIN_PYRAMID_PLINKO_ROWS,
  DEFAULT_NUMBER_OF_BALLS,
  DEFAULT_PLINKO_LIGHTNING_MODE_BOARD,
  DEFAULT_PLINKO_PINS,
  DEFAULT_PLINKO_RISK_LEVEL,
  PLINKO_FIXED_ODDS,
  getColorOfWinBox
} from './pyramidPlinkogame.constants'
import { COIN_CURRENCY_CODES } from 'games/CrashGames/GameTheme/FlyCrashGame/crashgame.constants'
import { useTranslation } from 'react-i18next'
import { getMyBetsPlinko, placedBetPlinkoGame } from '../../slices-thunks/pyramidPlinkoGame.thunk'
import ErrorMessage from 'components/ui-kit/ErrorMessage/index'
import './pyramidPlinkoGame.scss'
import { startLoadingAssets } from "./pixi-js-scripts/assetsLoad";
import { app } from "./pixi-js-scripts/appPixi";
import {
  pixiChangeNumberOfLines,
  pixiFastBall,
  pixiLightningMode,
  pixiNormalMode,
  pixiSetPayouts,
  pixiSlowBall,
  pixiStartMovingBall,
  setGameMode,
  setBetInProgress,
  getBetInProgress,
  setAutoBetActive,
  incrementPendingBets,
  resetPendingBets,
  setTotalAutoBetBalls,
  setBallLandedListener,
  waitForBallLanded,
  releaseBallWaiters
} from "./pixi-js-scripts/bridge";
import { containers, isSetupBoxes, relayout  } from "./pixi-js-scripts/gameUI";
import usePlinkoGameSocketNameSpace from "socket-resources/hooks/usePyramidPlinkoGameSocketNameSpace";
import {
  setLightningBoardDetails,
  setPyramidPlinkoLossCount,
  setPyramidPlinkoProfit,
  setPyramidPlinkoWagered,
  setPyramidPlinkoWinsCount,
  demoPlacedBetPyramidPlinkoGame,
  drainPendingBetsPlinko
} from "games/Plinko/slices-thunks/pyramidPlinkoGame.slice";
import Button from "components/ui-kit/Button/index";
import SwitchButton from "components/ui-kit/SwitchButton/index";
import { CrossIcon, MinusIcon, PlusIcon } from "assets/icons/index";
import SelectBox from "components/ui-kit/SelectBox/index";
import { getPrecision } from "helpers/common.helpers";
import { plus, minus } from "number-precision";
import SVGBackground from "./components/SVGBackground/index";
import {
  DEFAULT_GAME_ID,
  ROUTE_PATHS,
  WALLET_EMIT_TYPES,
} from "constants/index";
import {
  openSuccessToaster,
  openWarningToaster,
  openErrorToaster
} from "helpers/toaster.helpers";
import { ChangeSeedModal } from "components/molecules/ChangeSeedModal/index";
import GameFooter from "components/molecules/GameFooter/index";
import { resetGameHashDetails } from "redux-store/redux/slices/gameSettings.slice";
import HotkeysModal from "./components/HotkeysModal/index";
import OneToOneGameFairnessModal from "components/molecules/OneToOneGameFairnessModal/index";
import WalletBalance from "components/molecules/WalletBalance/index";
import { blockInvalidChar } from "utils/game.utils";
import {
  setUserInfo,
  updateDemoWalletBalance,
} from "redux-store/redux/slices/auth.slice";
import { getDummyBetResult, getMultiplierPayout } from "./pyramidPlinko.helper";
import GameHeader from "components/molecules/GameHeader/index";
// import useWalletSocketNameSpace from 'socket-resources/hooks/useWalletSocketNameSpace'
import { getAuthTokenFromCookie } from 'helpers/cookie.helpers'
import { playbetPlacedSound } from "./pixi-js-scripts/soundManager.js";
import TimeOutModal from './components/TimeoutModal/index.jsx'
import useUserSessionSocketNameSpace from 'socket-resources/hooks/useUserSessionSocketNameSpace'

let isAutoBetActive = false
const HISTORY_SIZE = 5;

const LIVE_BETS_DROPDOWN_OPTIONS = [{ value: '10', key: 10 }, { value: '20', key: 20 }, { value: '50', key: 50 }, { value: '100', key: 100 }]

const PyramidPlinkoGame = (props) => {
  const { listenLightningBoardDetails, removeListenLightningBoardDetails } = usePlinkoGameSocketNameSpace()
  const dispatch = useDispatch()
  const [isSessionExpired, setIsSessionExpired] = useState(false)
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const listenUserSessionDisconnect = useUserSessionSocketNameSpace()

  // const listenUserWallet = useWalletSocketNameSpace()
  const [maxBetError, setMaxBetError] = useState('');
  const { userInfo, isLoggedIn, currencyCode, demoMode, demoWallet } = useSelector((state) => state.auth)
  const { systemGameData, clientSeed, gameSound, gameMusic } = useSelector((state) => state.gameSetting)
  const { myBetsData, placedBetData, betLock, lightningBoardBallMultipliers, lightningBoardPayouts, liveBets, placedBets, profit, wagered, wins, losses, demoMyBets } = useSelector((state) => state.pyramidPlinkoGame)
  const [currentWallet, setCurrentWallet] = useState(null)
  const [betAmount, setBetAmount] = useState(0)
  const [betAmountError, setBetAmountError] = useState('')
  const [plinkoGameSetting, setPlinkoGameSetting] = useState(null)
  const [riskLevel, setRiskLevel] = useState(DEFAULT_PLINKO_RISK_LEVEL)
  const [numberOfRows, setNumberOfRows] = useState(DEFAULT_PLINKO_PINS)
  const [autoBet, setAutoBet] = useState(false)
  const [autoBetPlaced, setAutoBetPlaced] = useState(false)
  const [autoBetCounter, setAutoBetCounter] = useState(DEFAULT_AUTO_BET_COUNTER)
  const [autoBetPlacedCount, setAutoBetPlacedCount] = useState(DEFAULT_AUTO_BET_COUNTER)
  const [initialAutoBetCounter, setInitialAutoBetCounter] = useState(DEFAULT_AUTO_BET_COUNTER)
  const [fastMode, setFastMode] = useState(false)
  const [lightningMode, setLightningMode] = useState(false)
  const [isPixiAssetsLoaded, setIsPixiAssetsLoaded] = useState(false)
  const [disableMultiples, setDisableMultiples] = useState({
    disableDouble: false,
    disableHalf: false,
    disablePlus: false,
    disableMinus: false,
    disableMax: false,
    disableMin: false
  })
  const [selectedAutoBetValue, setSelectedAutoBetValue] = useState('10')
  const [liveBetsState, setLiveBetsState] = useState([])
  const [liveBetCount, setLiveBetCount] = useState(10)
  const [gameSettings, setGameSettings] = useState(false)
  const [isKeyBindEnabled, setIsKeyBindEnabled] = useState(false)
  const [isHotkeysModal, setIsHotkeysModal] = useState(false)
  const [openFairnessModal, setOpenFairnessModal] = useState(false)
  const [roundBetHistory, setRoundBetHistory] = useState(null)
  const [isSetting, setIsSetting] = useState(false)
  const [numberOfBalls, setNumberOfBalls] = useState(DEFAULT_NUMBER_OF_BALLS);
  const [betHistory, setBetHistory] = useState([]);
  const [singleBetStatus, setSingleBetStatus] = useState(false);

  const seenBetsRef = useRef(new Set());
  const { t } = useTranslation();
  const hasHydratedRef = useRef(false);
  const restoredFromStorageRef = useRef(false);

  const landedBets = useMemo(() => {
    if (demoMode) return [];
    return myBetsData?.rows ?? [];
  }, [demoMode, myBetsData?.rows]);

  useEffect(() => {
    seenBetsRef.current = new Set();
    setBetHistory([]);
    hasHydratedRef.current = false;
    restoredFromStorageRef.current = false;
  }, [demoMode]);

  const HISTORY_KEY = "pyramid-plinko-history";

  useEffect(() => {
      if (!isPixiAssetsLoaded) return
      let timer
      const onResize = () => {
        clearTimeout(timer)
        timer = setTimeout(() => {
          if (containers.ballContainer.length === 0) relayout()   // don't move the scene while balls are falling
        }, 200)                                                   // wait for Pixi's own resizeTo to finish
      }
      window.addEventListener('resize', onResize)
      window.addEventListener('orientationchange', onResize)
      return () => {
        clearTimeout(timer)
        window.removeEventListener('resize', onResize)
        window.removeEventListener('orientationchange', onResize)
      }
  }, [isPixiAssetsLoaded])

  useEffect(() => {
    if (demoMode || !placedBets?.length) return
    const timeoutId = setTimeout(() => {
      if (containers.ballContainer.length === 0) {
        dispatch(drainPendingBetsPlinko())
      }
    }, 7000)
    return () => clearTimeout(timeoutId)
  }, [demoMode, placedBets?.length > 0, dispatch])

  useEffect(() => {
    if (demoMode) return;
    try {
      const saved = JSON.parse(sessionStorage.getItem(HISTORY_KEY) ?? "[]");
      if (!Array.isArray(saved) || !saved.length) return;
      saved.forEach((row) => row?.betKey && seenBetsRef.current.add(row.betKey));
      setBetHistory(saved.slice(0, HISTORY_SIZE));
      restoredFromStorageRef.current = true;
    } catch (err) {
      console.debug("Plinko: history restore skipped", err?.message);
    }
  }, [demoMode]);

  useEffect(() => {
    if (demoMode) return;
    try {
      sessionStorage.setItem(HISTORY_KEY, JSON.stringify(betHistory));
    } catch (err) {
      console.debug("Plinko: history save skipped", err?.message);
    }
  }, [demoMode, betHistory]);

  useEffect(() => {
    if (demoMode || !landedBets.length) return;

    // walk oldest -> newest so prepending keeps the correct order
    const fresh = [];
    for (let i = landedBets.length - 1; i >= 0; i--) {
      const row = landedBets[i];
      if (!row) continue;
      const betKey = String(
        row.id ??
        `${row.roundId ?? ""}-${row.createdAt ?? ""}-${row.coefficient}`,
      );
      if (seenBetsRef.current.has(betKey)) continue;
      seenBetsRef.current.add(betKey);
      fresh.push({ ...row, betKey });
    }
    if (!fresh.length) return;

    if (!hasHydratedRef.current) {
      hasHydratedRef.current = true;
      if (restoredFromStorageRef.current) return;
      setBetHistory(fresh.slice(-HISTORY_SIZE).reverse());
      return;
    }

    setBetHistory((prev) => {
      let next = prev;
      for (const row of fresh) next = [row, ...next];
      return next.slice(0, HISTORY_SIZE);
    });
  }, [demoMode, landedBets]);

  const historyItems = useMemo(() => {
    if (demoMode) {
      return (demoMyBets ?? [])
        .slice(0, HISTORY_SIZE)
        .map((row, idx) => ({ ...row, betKey: row?.id ?? `demo-${idx}` }));
    }
    return betHistory;
  }, [demoMode, demoMyBets, betHistory]);

  const lines = useMemo(() => [8, 9, 10, 11, 12, 13, 14, 15, 16], [])

  const liveStats = {
    totalProfit: profit,
    totalWagered: wagered,
    totalWins: wins,
    totalLost: losses
  }

  const risks = useMemo(
    () => [
      {
        label: t('EASY'),
        value: 1
      },
      {
        label: t('NORMAL'),
        value: 2
      },
      {
        label: t('HARD'),
        value: 3
      }
    ],
    []
  )

  const increaseNumberOfRows = () => {
    const newNumberOfRows = numberOfRows + 1
    if (newNumberOfRows >= DEFAULT_MIN_PYRAMID_PLINKO_ROWS && newNumberOfRows <= DEFAULT_MAX_PYRAMID_PLINKO_ROWS) {
      handleChangeNumberOfLines(newNumberOfRows)
    }
  }

  const decreaseNumberOfRows = () => {
    const newNumberOfRows = numberOfRows - 1
    if (newNumberOfRows >= DEFAULT_MIN_PYRAMID_PLINKO_ROWS && newNumberOfRows <= DEFAULT_MAX_PYRAMID_PLINKO_ROWS) {
      handleChangeNumberOfLines(newNumberOfRows)
    }
  }

  const onKeyBinding = (event) => {
    switch (event.keyCode) {
      case 32:
        !autoBet
          ? document.getElementById('plinko-bet-button')?.click()
          : (!autoBetPlaced
            ? document.getElementById('plinko-bet-button')?.click()
            : document.getElementById('plinko-stop-auto-bet-button')?.click())
        break
      case 87:
        if (!betLock && !autoBetPlaced) handleDoubleBetAmount()
        break
      case 83:
        if (!betLock && !autoBetPlaced) handleHalfBetAmount()
        break
      case 65:
        if (!betLock && !autoBetPlaced) decreaseNumberOfRows()
        break
      case 68:
        if (!betLock && !autoBetPlaced) increaseNumberOfRows()
        break
      default:
        break
    }
  }

  const handleFairnessModal = () => {
    if (openFairnessModal) {
      dispatch(resetGameHashDetails())
    }
    if (myBetsData?.rows[0]) {
      setRoundBetHistory(myBetsData?.rows[0])
    }
    setOpenFairnessModal(!openFairnessModal)
  }

  const handleUserWalletData = ({ data }) => {
    if (data?.type && data?.type === WALLET_EMIT_TYPES.DEBIT) {
      dispatch(setUserInfo(data))
    }
  }

  useEffect(() => {
    if (isLoggedIn && !demoMode) {
      dispatch(getMyBetsPlinko({
        limit: 20,
        offset: 0
      }))

      const token = getAuthTokenFromCookie()
      const onSocketDisconnect = () => {
        setIsOffline(true)
      };
      const onSocketReconnect = () => {
        setIsOffline(false)
      };
      const cleanupUserSession = listenUserSessionDisconnect((data) => {
        data?.reason?.isSessionExpired && setIsSessionExpired(true)
      }, token, onSocketDisconnect, onSocketReconnect)

      // const clearListenUserWallet = listenUserWallet(handleUserWalletData, token)
      // return () => {
      //   clearListenUserWallet()
      // }
    }
  }, [isLoggedIn, demoMode])

  useEffect(() => {
    const handleOffline = () => { setIsOffline(true) };
    const handleOnline = () => setIsOffline(false);
    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);
    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  useEffect(() => {
    document.getElementById('pixi-plinko-game').appendChild(app.view)

    // OPTIMIZATION: Warm up HTTP connection pool early
    // This causes TCP/TLS handshake to occur now, before first real bet
    const warmupConnection = async () => {
      try {
        await fetch(`${process.env.REACT_APP_BACKEND_URL_HTTP}/fast-games/plinko-game/place-bet`, {
          method: 'HEAD',
          credentials: 'include',
          mode: 'cors'
        }).catch((err) => {
          console.error("Plinko: HTTP warmup skipped", err?.message);
        });
        console.debug('Plinko: HTTP connection pool warmed up')
      } catch (err) {
        console.error('Plinko: HTTP warmup skipped', err?.message)
      }
    }
    warmupConnection()
    startLoadingAssets(setIsPixiAssetsLoaded)
  }, [])

  useEffect(() => {
    if (isPixiAssetsLoaded && isSetupBoxes && (riskLevel >= 0) && (numberOfRows >= 8 && numberOfRows <= 16) && !lightningMode && plinkoGameSetting?.houseEdge) {
      const multipliers = getMultiplierPayout(numberOfRows, riskLevel, plinkoGameSetting)
      pixiSetPayouts(multipliers)
    }
  }, [numberOfRows, riskLevel, isSetupBoxes, isPixiAssetsLoaded, lightningMode, plinkoGameSetting?.houseEdge])

  useEffect(() => {
    if (systemGameData && userInfo?.wallet) {
      const currentWalletData = userInfo?.wallet
      setCurrentWallet(currentWalletData)
    }
  }, [userInfo, systemGameData])

  useEffect(() => {
    if (demoMode) {
      setCurrentWallet(demoWallet)
    }
  }, [demoMode, demoWallet])

  useEffect(() => {
    if (systemGameData && !systemGameData.find(ele => Number(ele.gameId) === Number(DEFAULT_GAME_ID.PYRAMID_PLINKO))) {
      history.push(ROUTE_PATHS.home)
    }
  }, [systemGameData])

  useEffect(() => {
    if (!autoBetPlaced || autoBetCounter <= 0) {
      // if (autoBetPlaced && autoBetCounter <= 0) {
      //   isAutoBetActive = false
      //   setBetInProgress(false)
      //   setAutoBetPlaced(false)
      //   setAutoBetCounter(initialAutoBetCounter)
      //   setAutoBetPlacedCount(initialAutoBetCounter)
      //   openSuccessToaster({
      //     message: 'Auto Bet Stopped'
      //   })
      // }

      return
    }

    let cancelled = false

    const placeNextBet = async () => {
      try {
        //setAutoBetPlacedCount((prevCount) => prevCount - 1)
        // This waits until the previous API request succeeds.
        await handleBetPlace(true)
        if (cancelled) return

        await waitForBallLanded()   // 👈 wait until this ball touches the win box
        if (cancelled) return
        // Only after successful API response:
        setAutoBetCounter((prevCount) => prevCount - 1)
      } catch (error) {
        if (cancelled) return
        console.error('Auto bet failed:', error)
        isAutoBetActive = false
        setBetInProgress(false)
        setAutoBetPlaced(false)
        setAutoBetCounter(initialAutoBetCounter)
        setAutoBetPlacedCount(initialAutoBetCounter)
        openErrorToaster({
          message: 'Auto Bet stopped because the bet request failed.'
        })
      }
    }

    placeNextBet()

    return () => {
      cancelled = true
      releaseBallWaiters()
    }
  }, [autoBetPlaced, autoBetCounter])

  // Decrement the "Cancel N Bets" label when a ball touches the win box
  useEffect(() => {
    if (!autoBetPlaced) {
      setBallLandedListener(null)
      return
    }
    setBallLandedListener(() => {
      setAutoBetPlacedCount((prev) => Math.max(Number(prev) - 1, 0))
    })
    return () => setBallLandedListener(null)
  }, [autoBetPlaced])

  // Finish auto-bet once all bets are placed AND all balls have landed
  useEffect(() => {
    if (autoBetPlaced && autoBetCounter <= 0 && Number(autoBetPlacedCount) <= 0) {
      isAutoBetActive = false
      setBetInProgress(false)
      setAutoBetPlaced(false)
      setAutoBetCounter(initialAutoBetCounter)
      setAutoBetPlacedCount(initialAutoBetCounter)
      openSuccessToaster({ message: 'Auto Bet Stopped' })
    }
  }, [autoBetPlaced, autoBetCounter, autoBetPlacedCount])

  useEffect(() => {
    if (systemGameData && currencyCode) {
      const gamesSettings = systemGameData?.find(
        (ele) => ele.gameId === DEFAULT_GAME_ID.PYRAMID_PLINKO
      )
      const maxBetData = gamesSettings?.maxBet[currencyCode]
      const maxProfitData = gamesSettings?.maxProfit[currencyCode]
      const minBetData = gamesSettings?.minBet[currencyCode]
      const houseEdge = +gamesSettings?.houseEdge
      setPlinkoGameSetting({ maxBetData, maxProfitData, minBetData, houseEdge })
      if (minBetData) {
        const minCurrentUnitAmount = (+minBetData <= DEFAULT_BET_AMOUNT && +maxBetData >= DEFAULT_BET_AMOUNT)
          ? DEFAULT_BET_AMOUNT
          : minBetData
        setBetAmount(
          Number(minCurrentUnitAmount)
            .toFixed(2)
            .replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1')
        )
      }
    }
  }, [systemGameData, currencyCode])

  useEffect(() => {
    if (currentWallet) {
      const currentBetAmount = parseFloat(betAmount)
      const _disableMultiples = {
        disableDouble: false,
        disableHalf: false,
        disablePlus: false,
        disableMinus: false,
        disableMax: false,
        disableMin: false
      }
      if (currentBetAmount > +plinkoGameSetting?.minBetData) {
        _disableMultiples.disableHalf = false
        _disableMultiples.disableMinus = false
      } else {
        _disableMultiples.disableHalf = true
        _disableMultiples.disableMinus = true
      }

      if (currentBetAmount === +plinkoGameSetting?.minBetData) {
        _disableMultiples.disableMin = true
      } else {
        _disableMultiples.disableMin = false
      }

      if (currentBetAmount === +plinkoGameSetting?.maxBetData) {
        _disableMultiples.disableMax = true
      } else {
        _disableMultiples.disableMax = false
      }

      if (
        currentBetAmount > currentWallet.balance || currentBetAmount >= +plinkoGameSetting?.maxBetData
      ) {
        _disableMultiples.disableDouble = true
        _disableMultiples.disablePlus = true
      } else if (currentBetAmount > 0) {
        _disableMultiples.disableDouble = false
        _disableMultiples.disablePlus = false
      }
      setDisableMultiples(prev => ({
        ...prev,
        ..._disableMultiples
      }))
    }
  }, [currentWallet, betAmount])

  useEffect(() => {
    if (liveBets?.rows) {
      const placedBetsId = placedBets?.map(bet => bet?.id) ?? []
      const _liveBets = liveBets?.rows?.filter(bet => {
        if (betLock && placedBetsId?.length > 0) {
          return placedBets ? !(placedBetsId?.includes(bet?.id)) : true
        }
        return true
      })?.slice(0, liveBetCount)

      setLiveBetsState(_liveBets)
    }
  }, [liveBets?.rows, betLock, placedBets, liveBetCount])

  useEffect(() => {
    if (isKeyBindEnabled) {
      document.addEventListener('keydown', onKeyBinding)
    } else {
      document.removeEventListener('keydown', onKeyBinding)
    }
    return () => {
      document.removeEventListener('keydown', onKeyBinding)
    }
  }, [plinkoGameSetting, betAmount, autoBet, autoBetPlaced, isKeyBindEnabled, increaseNumberOfRows, decreaseNumberOfRows])

  const handleChangeNumberOfLines = useCallback((line) => {
    setNumberOfBalls(line)
    if (isPixiAssetsLoaded && containers.ballContainer.length === 0) {
      setNumberOfRows(line)
      pixiChangeNumberOfLines(line)
    } else {
      openWarningToaster({ message: 'Cannot change number of lines when game is running!' })
    }
  }, [isPixiAssetsLoaded, containers?.ballContainer?.length])

  const handleHalfBetAmount = () => {
    if (parseFloat(betAmount) > 0) {
      const newBetAmount = parseFloat(betAmount) / 2
      if (newBetAmount < +plinkoGameSetting?.minBetData) {
        setDisableMultiples(prev => ({
          ...prev,
          disableHalf: true
        }))
        setBetAmount(+plinkoGameSetting?.minBetData)
      } else {
        setBetAmount(
          parseFloat(newBetAmount)
            .toFixed(2)
            .replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1')
        )
      }
    }
  }

  const handleDoubleBetAmount = () => {
    if (parseFloat(betAmount) > 0) {
      const newBetAmount = parseFloat(betAmount) * 2
      if (newBetAmount > +plinkoGameSetting?.maxBetData) {
        setDisableMultiples(prev => ({
          ...prev,
          disableDouble: true
        }))
        setBetAmount(+plinkoGameSetting?.maxBetData)
      } else {
        setBetAmount(
          newBetAmount.toFixed(2).replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1')
        )
      }
    }
  }

  const handleMinBetAmount = () => {
    const currentWAlletBlc =
      userInfo && userInfo?.wallet ? userInfo.wallet.balance : 0
    const maxAmount =
      currentWAlletBlc > +(+plinkoGameSetting?.minBetData)
        ? +(+plinkoGameSetting?.minBetData)
        : currentWAlletBlc
    setBetAmount(maxAmount)
    setBetAmountError('')
  }

  const handleMaxBetAmount = () => {
    const currentWAlletBlc =
      userInfo && userInfo?.wallet ? userInfo.wallet.balance : 0
    const maxAmount =
      currentWAlletBlc > +plinkoGameSetting?.maxBetData
        ? +plinkoGameSetting?.maxBetData
        : currentWAlletBlc
    setBetAmount(maxAmount)
    setBetAmountError('')
  }

  const handleMinusBetAmount = () => {
    if (parseFloat(betAmount) > 0) {
      const step = +plinkoGameSetting?.minBetData || 1  // ← use minBet as step
      const newBetAmount = minus(parseFloat(betAmount), step)
      if (newBetAmount < +(+plinkoGameSetting?.minBetData)) {
        setDisableMultiples(prev => ({
          ...prev,
          disableMinus: true
        }))
        handleMinBetAmount()
      } else {
        setBetAmount(parseFloat(newBetAmount).toFixed(2).replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1'))
      }
    }
  }

  const handlePlusBetAmount = () => {
    if (parseFloat(betAmount) > 0) {
      const step = +plinkoGameSetting?.minBetData || 1
      const newBetAmount = plus(parseFloat(betAmount), step)
      if (newBetAmount > +(+plinkoGameSetting?.maxBetData)) {
        setDisableMultiples(prev => ({
          ...prev,
          disablePlus: true
        }))
        handleMaxBetAmount()
      } else if (newBetAmount >= currentWallet?.balance) {
        const _betAmount = `${getPrecision(currentWallet?.balance)}`.replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1')
        setBetAmount(_betAmount)
        setDisableMultiples(prev => ({
          ...prev,
          disablePlus: true
        }))
      } else {
        setBetAmount(newBetAmount.toFixed(2).replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1'))
      }
    }
  }

  const checkBetAmountValidation = (_newBetAmount) => {
    const realBetAmount = +_newBetAmount
    setBetAmountError('')
    if (isNaN(realBetAmount)) {
      setBetAmountError(t('isRequired', { label: t('betAmount') }))
    }
    if (realBetAmount > currentWallet?.balance) {
      setBetAmountError(t('noBalance'))
    } else {
      if (realBetAmount > +plinkoGameSetting?.maxBetData) {
        //setBetAmountError(t('maxBetAmountLimit', { value: `${Number(plinkoGameSetting?.maxBetData)?.toFixed(2)} ${currencyCode}` }))
        setBetAmountError(t('maxBetAmountLimit', { value: `${Number(plinkoGameSetting?.maxBetData).toLocaleString('en-US')} ${currencyCode}` }))
      } else if (realBetAmount < +plinkoGameSetting?.minBetData) {
        //setBetAmountError(t('minBetAmountLimit', { value: `${Number(plinkoGameSetting?.minBetData)?.toFixed(2)} ${currencyCode}` }))
        setBetAmountError(t('minBetAmountLimit', { value: `${Number(plinkoGameSetting?.minBetData).toLocaleString('en-US')} ${currencyCode}` }))
      }
    }
  }

  const handleBetAmountChange = (e) => {
    // if (setBetAmountError?.length) {
    //   setBetAmountError('')
    // }
    // checkBetAmountValidation(e.target.value)
    // setBetAmount(e.target.value.length < 8 ? e.target.value : e.target.value.slice(0, 8))

    // Strip commas first
    let raw = e.target.value.replace(/,/g, '')  // strip commas

    // Allow empty
    if (raw === '') {
      setBetAmount('')
      return
    }

    // Block leading dot
    if (raw.startsWith('.')) {
      raw = '0' + raw
    }

    // Safety check for non-numeric
    if (isNaN(raw)) return

    // Restrict to 2 decimal places
    if (raw.includes('.')) {
      const [integer, decimal] = raw.split('.')
      raw = `${integer}.${decimal.slice(0, 2)}`
    }

    const walletBalance = currentWallet?.balance ? +currentWallet.balance : 0;
    const maxBet = +plinkoGameSetting?.maxBetData;
    const balanceIsLower = walletBalance > 0 && walletBalance < maxBet;
    const effectiveMax = balanceIsLower ? walletBalance : maxBet;

    if (parseFloat(raw) > effectiveMax) {
      // reject the keystroke — do NOT update betAmount, just warn
      setBetAmountError(
        balanceIsLower
          ? t("noBalance")
          : t("maxBetAmountLimit", {
            value: `${Number(maxBet).toLocaleString("en-US")} ${currencyCode}`,
          })
      );
      setTimeout(() => setBetAmountError(""), 2000);
      return;
    }

    if (setBetAmountError?.length) {
      setBetAmountError('')
    }

    checkBetAmountValidation(raw)
    setBetAmount(raw.length < 8 ? raw : raw.slice(0, 8))
  }

  const handleBetPlace = async (isAutoBet = false) => {
    if (getBetInProgress()) {
      incrementPendingBets()
    } else {
      setBetInProgress(true);
      if (!isAutoBet) {
        setAutoBetActive(false); // only reset auto flag for genuine manual bets
      } // ensure auto flag is off for manual bets
    }
    const realBetAmount = +betAmount
    if (realBetAmount === 0) {
      setBetAmountError('Please provide Bet amount')
    } else if (realBetAmount < 0) {
      setBetAmountError('Please provide valid Bet amount')
    } else if (realBetAmount > currentWallet?.balance) {
      //setBetAmountError(t("noBalance"));
      openErrorToaster({
        message: `${'Insufficient funds.'}`
      })
      setBetAmountError(t('noBalance'))
    } else {
      if (realBetAmount > +plinkoGameSetting?.maxBetData) {
        //setBetAmountError(t('maxBetAmountLimit', { value: `${Number(plinkoGameSetting?.maxBetData)?.toFixed(2)} ${currencyCode}` }))
        setBetAmountError(t('maxBetAmountLimit', { value: `${Number(plinkoGameSetting?.maxBetData).toLocaleString('en-US')} ${currencyCode}` }))
      } else if (realBetAmount < +plinkoGameSetting?.minBetData) {
        //setBetAmountError(t('minBetAmountLimit', { value: `${Number(plinkoGameSetting?.minBetData)?.toFixed(2)} ${currencyCode}` }))
        setBetAmountError(t('minBetAmountLimit', { value: `${Number(plinkoGameSetting?.minBetData).toLocaleString('en-US')} ${currencyCode}` }))
      } else {
        setSingleBetStatus(true)
        const payload = {
          numberOfRows,
          riskLevel: riskLevel,
          betAmount: Number(realBetAmount),
          clientSeed,
          isLightningMode: lightningMode
        }
        if (!autoBet) playbetPlacedSound()
        if (demoMode) {
          // Demo play logic fully on frontend
          //const timeDuration = autoBet ? 300 * numberOfBalls : 300
          const timeDuration = autoBet ? 0 : 300
          setTimeout(() => {
            const res = getDummyBetResult(
              numberOfBalls,
              numberOfRows,
              riskLevel,
              betAmount,
              plinkoGameSetting,
              clientSeed,
            );

            const winningAmountStr = `${CURRENCY_SYMBOL[currencyCode]} ${Number(res?.winningAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            const multiplierStr = `${(+(divide(+res?.winningAmount, res?.betAmount)))?.toFixed(2)}x`;

            const dropDetails = res.dropDetails;
            for (let i = 0; i < dropDetails.length; i++) {
              const lastBall = (i + 1) === dropDetails.length
              setTimeout(() => {
                pixiStartMovingBall(
                  dropDetails[i],
                  lastBall,
                  res.winningAmount,
                  winningAmountStr,   // ← pass through
                  multiplierStr,
                );
                // console.log('lastBall :>> ', lastBall)
                // pixiCreateBall(lastBall, res.winningAmount)
              }, 75 * i)
            }
            const newBalance = demoWallet.balance - res.betAmount
            dispatch(updateDemoWalletBalance(getPrecision(newBalance)))
            dispatch(demoPlacedBetPyramidPlinkoGame(res))
          }, timeDuration)
        } else {
          // setting Timeout so that if the api is called multiple times there will be a delay.
          //const timeDuration = autoBet ? 300 * numberOfBalls : 300
          // const timeDuration = autoBet ? 100 : 300
          // setTimeout(() => {
          // dispatch(placedBetPlinkoGame({ payload, currencyCode }))
          //}, timeDuration)

          const response = await dispatch(
            placedBetPlinkoGame({
              payload,
              autoBet: isAutoBet,
              currencyCode,
            })
          ).unwrap()

          setSingleBetStatus(false)

          return response

        }
        // dispatch(placedBetPlinkoGame({ payload, fastMode: false, autoBet, currencyCode }))
      }
    }
  }

  const handleAutoBetPlace = async () => {
    const parsedCounter = parseInt(autoBetCounter, 10);
    const realBetAmount = +betAmount;
    const walletBalance = currentWallet?.balance ? +currentWallet.balance : 0;

    if (betAmountError.length > 0) {
      setBetAmountError('');
    }

    // 👇 upfront check: can the wallet cover ALL rounds, not just the first?
    const totalRequiredAmount = realBetAmount * parsedCounter;
    if (totalRequiredAmount > walletBalance) {
      setBetAmountError(
        t('inSufficientBalanceWarning'));
      return;
    }

    setTotalAutoBetBalls(autoBetCounter)
    resetPendingBets()
    setAutoBetActive(true)

    if (realBetAmount > currentWallet?.balance) {
      setBetAmountError(t('inSufficientBalanceWarning'))
    } else {
      const currentCurrency = demoMode ? demoWallet.currency : userInfo?.wallet?.currency?.toUpperCase()
      if (realBetAmount > +plinkoGameSetting?.maxBetData) {
        setBetAmountError(
          `${t('maxBetAmountLimit')} ${t('limit')}`
        )
      } else if (realBetAmount < +plinkoGameSetting?.minBetData) {
        setBetAmountError(
          `${t('minBetAmountLimit')} ${+plinkoGameSetting?.minBetData?.toFixed(
            2
          )} ${currentCurrency} ${t('notAchieved')}`
        )
      } else {
        if (autoBetCounter > 0) {
          playbetPlacedSound();
          openSuccessToaster({ message: "Auto Bet Started" });
          setAutoBetPlaced(true);
          // try {
          //   const payload = {
          //     numberOfRows,
          //     riskLevel: riskLevel,
          //     betAmount: Number(realBetAmount),
          //     clientSeed,
          //     isLightningMode: lightningMode,
          //   };
          //   if (demoMode) {
          //     // Demo play logic fully on frontend
          //     const res = getDummyBetResult(
          //       numberOfBalls,
          //       numberOfRows,
          //       riskLevel,
          //       betAmount,
          //       plinkoGameSetting,
          //       clientSeed,
          //     );
          //     const dropDetails = res.dropDetails;
          //     for (let i = 0; i < dropDetails.length; i++) {
          //       const lastBall = i + 1 === dropDetails.length;
          //       setTimeout(() => {
          //         pixiStartMovingBall(
          //           dropDetails[i],
          //           lastBall,
          //           res.winningAmount,
          //         );
          //         // pixiCreateBall(lastBall, res.winningAmount)
          //       }, 75 * i);
          //     }
          //     const newBalance = demoWallet.balance - res.betAmount;
          //     dispatch(updateDemoWalletBalance(getPrecision(newBalance)));
          //     dispatch(demoPlacedBetPyramidPlinkoGame(res));
          //   } else {
          //     openSuccessToaster({ message: "Auto Bet Started" });
          //     dispatch(
          //       placedBetPlinkoGame({ payload, autoBet: true, currencyCode }),
          //     );
          //     const timeoutId = setTimeout(() => {
          //       setAutoBetCounter((prevCount) => prevCount - 1);
          //       handleBetPlace(true);   // 👈 mark this as an auto-loop-triggered call
          //     }, 100);
          //   }
          // } catch (e) {
          //   setAutoBetCounter(initialAutoBetCounter);
          //   setAutoBetPlaced(false);
          // }
        } else {
          setBetAmountError('Invalid auto bet count')
        }
      }
    }
  }

  const cancelAutoBetHandler = () => {
    isAutoBetActive = false
    setBetInProgress(false)
    setAutoBetActive(false)
    resetPendingBets()
    setAutoBetCounter(initialAutoBetCounter)
    setAutoBetPlacedCount(initialAutoBetCounter)
    setAutoBetPlaced(false)
    openSuccessToaster({ message: t('AUTO_BET_STOPPED') })
  }

  const lineButtons = useMemo(
    () =>
      lines.map((line) => (
        <button
          disabled={betLock || lightningMode || autoBetPlaced}
          className={`line-btn rounded-3 fw-bold px-0 ${line === numberOfRows ? 'active' : ''
            }`}
          key={line}
          onClick={e => {
            if (line !== numberOfRows) {
              handleChangeNumberOfLines(line)
            }
          }}
        >
          {line}
        </button>
      )),
    [lines, numberOfRows, betLock, lightningMode, autoBetPlaced, handleChangeNumberOfLines]
  )

  const handleToggleLightningMode = useCallback(() => {
    if (!lightningMode && isPixiAssetsLoaded) {
      handleChangeNumberOfLines(16)
      setLightningMode(true)
      listenLightningBoardDetails((e) => {
        if (isPixiAssetsLoaded) {
          const { betMultipliers, payouts } = e.data || DEFAULT_PLINKO_LIGHTNING_MODE_BOARD
          pixiLightningMode(betMultipliers, payouts)
          dispatch(setLightningBoardDetails({ betMultipliers, payouts }))
        }
      })
      pixiLightningMode(lightningBoardBallMultipliers, lightningBoardPayouts)
    }

    if (!isPixiAssetsLoaded) {
      openWarningToaster({ message: t('PLEASE_WAIT_FOR_THE_GAME_TO_LOAD') })
    }
  }, [handleChangeNumberOfLines, lightningMode, isPixiAssetsLoaded, lightningBoardBallMultipliers, lightningBoardPayouts])

  const handleToggleRiskLevel = useCallback((risk) => {
    if (lightningMode) {
      setLightningMode(false)
      removeListenLightningBoardDetails()
      pixiNormalMode(PLINKO_FIXED_ODDS[numberOfRows][riskLevel - 1])
    }
    setRiskLevel(risk)
    setGameMode(risk)
  }, [lightningMode, isPixiAssetsLoaded, numberOfRows, riskLevel])

  const riskLevels = useMemo(() => risks.map((elem) => {
    return (
      <div className='col' key={elem.label}>
        <Button
          disabled={betLock || autoBetPlaced}
          className={`btn-plinko-mode w-100 btn-plinko-primary ${elem.value === riskLevel && !lightningMode ? "active" : ""}`}
          onClick={() => handleToggleRiskLevel(elem.value)}
        >
          {elem.label}
        </Button>
      </div>
    )
  }), [riskLevel, betLock, lightningMode, autoBetPlaced, handleToggleLightningMode, handleToggleRiskLevel])

  const handleFastMode = () => {
    if (fastMode) {
      pixiSlowBall()
    } else {
      pixiFastBall()
    }
    setFastMode((prev) => !prev)
  }

  const resetStats = () => {
    dispatch(setPyramidPlinkoLossCount({ reset: 0 }))
    dispatch(setPyramidPlinkoWinsCount({ reset: 0 }))
    dispatch(setPyramidPlinkoProfit(0))
    dispatch(setPyramidPlinkoWagered(0))
  }
  return (
    <div className='game-background plinko-game-wrapper'>
      {/* mobile settings  */}
      {gameSettings && <div className='game-setting-mobile-overlay' onClick={() => setGameSettings(!gameSettings)} />}
      <div className={`game-setting-mobile-view ${gameSettings ? 'setting-open' : ''} d-lg-none`}>
        <div className='container'>
          <div className='mobileGameSettingHeaderSection pt-4 d-flex justify-content-between'>
            <h5 className='fw-bold'>
              {t('GAME_SETTINGS')}
            </h5>
            <div className='btn-close-mobile-game-setting' onClick={() => setGameSettings(!gameSettings)}>
              {t('CLOSE')}
              <Button className='btn-outline-primary ms-1 btn-close-modal p-0 w-26'>
                <CrossIcon />
              </Button>
            </div>
          </div>
          <hr className='hr-line' />
          <div className='tabSection mb-3'>
            <label className='mb-2'>{t('DIFFICULTY')}</label>
            <div className='row'>{riskLevels}</div>
          </div>

          <div className='lineSection mb-3'>
            <label className='mb-2'>{t('LINES')}</label>
            <div className='d-flex lines-row flex-wrap'>{lineButtons}</div>
          </div>

          <div className='lineSection mb-3'>
            <label className='mb-2'>{t('GAME_SPEED')}</label>
            <div>
              <span className='btn-plinko-switch d-inline-flex align-items-center justify-content-between'>
                <label htmlFor='flexSwitchCheckChecked' className='text-white fw-bold me-3'>{fastMode ? t('FAST') : t('NORMAL')}</label>
                <SwitchButton
                  disabled={autoBetPlaced || betLock}
                  type='checkbox'
                  className='custom-switch plinko-switch-input'
                  id='flexSwitchCheckChecked'
                  value={fastMode}
                  onClick={handleFastMode}
                />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className='main-plinko-pixi-container position-relative'>
        {/* <div id='pixi-plinko-bgApp' /> */}
        <SVGBackground riskLevel={riskLevel} />
        <div className='plinko-overlay-container position-absolute inset-0 bottom-auto mb-4 pt-0 pt-lg-4'>
          <GameHeader
            gameSound={gameSound}
            gameMusic={gameMusic}
            handleFairnessModal={handleFairnessModal}
          />
          <div className='d-none d-lg-flex justify-content-end px-3'>
            <WalletBalance />
          </div>
          <div className='container flex-grow-1'>
            <div className='row gx-0 pyramid-plinko-row h-100'>
              <div className='d-flex flex-column col-12  col-lg-auto plinko-game-sidebar-col p-2 p-md-4 order-1 order-lg-0 mb-0 mb-md-3'>
                <div className='order-3 order-lg-0 tabSection mb-3'>
                  <label className='mb-2'>{t('DIFFICULTY')}</label>
                  <div className='row'>{riskLevels}</div>
                </div>

                <div className='order-2 order-lg-0 lineSection mb-3'>
                  <label className='mb-2'>{t('LINES')}</label>
                  <div className='d-flex lines-row flex-wrap'>{lineButtons}</div>
                </div>

                <div className='order-2 order-lg-0 lineSection mb-3'>
                  <label className='mb-2'>{t('GAME_SPEED')}</label>
                  <div>
                    <span className='btn-plinko-switch d-inline-flex align-items-center justify-content-between'>
                      <label htmlFor='flexSwitchCheckChecked' className='text-white fw-bold me-3'>{fastMode ? t('FAST') : t('NORMAL')}</label>
                      <SwitchButton
                        disabled={autoBetPlaced || betLock}
                        type='checkbox'
                        className='custom-switch plinko-switch-input'
                        id='flexSwitchCheckChecked'
                        value={fastMode}
                        onClick={handleFastMode}
                      />
                    </span>
                  </div>
                  <hr className='hr-line' />
                </div>
                <div className='order-2 order-lg-0 gameSpeedSection mb-2 mb-lg-3'>
                  <label className='mb-2 d-none d-lg-block'>{t('GAME_MODE')}</label>
                  <div className='d-flex gap-10'>
                    <div className='flex-shrink-0'>
                      <Button
                        disabled={autoBetPlaced || betLock}
                        className={`btn-plinko-primary rounded-10 ${!autoBet ? 'active' : ''}`}
                        onClick={() => setAutoBet(false)}
                      >
                        Manual
                      </Button>
                    </div>
                    <div className='flex-shrink-0'>
                      <Button
                        disabled={autoBetPlaced || betLock}
                        className={`btn-plinko-primary rounded-10 ${autoBet ? 'active' : ''}`}
                        onClick={() => setAutoBet(true)}
                      >
                        {t('AUTO')}
                      </Button>
                    </div>
                    <div className='flex-grow-1'>
                      <input
                        min={0}
                        type='number'
                        inputMode='numeric'
                        disabled={autoBetPlaced || !autoBet || betLock}
                        className='form-control numbers-bet-input'
                        // placeholder={t('TOTAL_BET')}
                        value={initialAutoBetCounter}
                        onFocus={() => { autoBetCounter === 0 && setAutoBetCounter('') }}
                        onBlur={() => { isNaN(parseFloat(autoBetCounter)) && setAutoBetCounter(0) }}
                        onChange={(e) => {
                          if (e.target.value?.length > 5) {
                            return
                          }
                          const _autoBetCount = +(e.target.value)
                          if (_autoBetCount > 100) {
                            setMaxBetError(t('MAXIMUM_AUTO_BET_ONE_TIME'))
                            setAutoBetCounter('100')
                            setTimeout(() => setMaxBetError(''), 10000);
                            return
                          }
                          setMaxBetError('')
                          setAutoBetCounter(e.target.value)
                          setInitialAutoBetCounter(e.target.value)
                          setAutoBetPlacedCount(e.target.value)
                        }}

                        onKeyDown={(e) => {
                          if (["e", "E", "+", "-", "."].includes(e.key)) {
                            e.preventDefault();
                            return;
                          }
                          blockInvalidChar?.(e);
                        }}
                      />
                    </div>


                  </div>
                  <br></br>
                  {maxBetError && <ErrorMessage message={maxBetError} style={{ color: 'red' }} />}
                  <hr className="hr-line mt-0 mb-2 mb-lg-3" />
                </div>
                <div className='order-1 order-lg-0 autoBetSection mb-2 mb-lg-3'>
                  <label className='mb-2 d-none d-lg-block'>{t('betAmount')}</label>
                  <div className='d-flex gap-3 flex-column'>
                    <div className='input-group bet-amount-input mb-lg-2'>
                      <span className='input-group-text p-0'>
                        <Button disabled={disableMultiples.disableMinus || betLock || autoBetPlaced} onClick={handleMinusBetAmount} className='fw-bold rounded-3'>
                          <MinusIcon />
                        </Button>
                      </span>
                      <input
                        type='text'
                        className='form-control text-center fw-bold px-0 px-md-2'
                        inputMode='decimal'
                        pattern='[0-9]*[.,]?[0-9]*'
                        autoComplete='off'
                        placeholder={t('betAmount')}
                        value={betAmount !== '' && betAmount !== undefined
                          ? betAmount.toString().includes('.')
                            ? betAmount
                            : Number(betAmount).toLocaleString('en-US')
                          : ''}
                        onChange={(e) => {
                          e.target.value = e.target.value.replace(/[^\d.,]/g, '')
                          handleBetAmountChange(e)
                        }}
                        onKeyDown={blockInvalidChar}
                        disabled={autoBetPlaced || betLock}
                        onFocus={() => { betAmount === 0 && setBetAmount('') }}
                        onBlur={() => { isNaN(parseFloat(betAmount)) && setBetAmount(0) }}
                      />
                      <span className='input-group-text p-0'>
                        <Button disabled={disableMultiples.disablePlus || betLock || autoBetPlaced} onClick={handlePlusBetAmount} className='fw-bold rounded-3'>
                          <PlusIcon />
                        </Button>
                      </span>
                    </div>
                    {betAmountError && (
                      <ErrorMessage message={betAmountError} style={{ color: 'red' }} />
                    )}
                    <div className="row mx-0 flex-nowrap gx-1 mul-button">
                      <div className="col-3 col-md align-self-center">
                        <Button
                          disabled={disableMultiples.disableMin || autoBetPlaced || betLock}
                          className='btn-plinko-primary rounded-10 text-white w-100 px-1 px-md-2'
                          onClick={handleMinBetAmount}
                        >
                          {t('MIN')}
                        </Button>
                      </div>
                      <div className='col-3 col-md align-self-center'>
                        <Button
                          className='btn-plinko-primary rounded-10 text-white w-100 px-1 px-md-2'
                          onClick={handleHalfBetAmount}
                          disabled={disableMultiples.disableHalf || autoBetPlaced || betLock}
                        >
                          1/2
                        </Button>
                      </div>
                      <div className='col-3 col-md align-self-center'>
                        <Button
                          className='btn-plinko-primary rounded-10 text-white w-100 px-1 px-md-2'
                          onClick={handleDoubleBetAmount}
                          disabled={disableMultiples.disableDouble || autoBetPlaced || betLock}
                        >
                          2X
                        </Button>
                      </div>
                      <div className='col-3 col-md align-self-center'>
                        <Button
                          disabled={disableMultiples.disableMax || autoBetPlaced || betLock}
                          className='btn-plinko-primary rounded-10 text-white w-100 px-1 px-md-2'
                          onClick={handleMaxBetAmount}
                        >
                          {t('MAX')}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='order-0 order-lg-0 fastMode mt-2 mt-lg-0 mb-2'>
                  <div>
                    <div>
                      {autoBetPlaced ? (
                        <Button
                          disabled={Number(autoBetPlacedCount) === 0}
                          className="btn-plinko-success fw-bold btn-plinko-bet w-100"
                          onClick={cancelAutoBetHandler}
                        >
                          {Number(autoBetPlacedCount) <= 0 ? (
                            <div className="spinner-border" />
                          ) : (
                            `Cancel ${autoBetPlacedCount} Bets`
                          )}
                        </Button>
                      ) : (
                        <Button
                          disabled={
                            !isPixiAssetsLoaded ||
                            (autoBet && betLock) ||
                            singleBetStatus
                          }
                          className="btn-plinko-success fw-bold btn-plinko-bet w-100"
                          onClick={() => (autoBet ? handleAutoBetPlace(true) : handleBetPlace())}
                        >
                          
                          {singleBetStatus ? (
                            <div className="spinner-border" role="status" />
                          ) : (
                            autoBet ? t('START') : t('PLACE_BET')
                          )}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12 col-lg order-0 order-lg-1 d-flex plinko-pixi-col'>
                <div id='pixi-plinko-game' className='w-100 align-self-center align-self-xl-end' />
              </div>
              <div className='col-auto col-lg-auto order-0 order-lg-1 mb-3 plinko-bet-history-col history-sidebar'>
                <ul className='plinko-bet-history position-relative mt-lg-4 ps-0'>
                  {
                    (demoMode ? demoMyBets : myBetsData?.rows)?.length > 0 &&
                    (demoMode ? demoMyBets : myBetsData?.rows)?.slice(0, 5)?.map((data, index) => {
                      //console.log('bet history row:', data)
                      const totalLines = data?.numberOfRows
                      //const boxIndex = data?.winningSlot?.[0]
                      const boxIndex = data?.winningSlot;
                      const color = getColorOfWinBox(boxIndex, totalLines) ?? BOX_COLORS.green

                      if (!data) {
                        return (
                          <li key={data?.id} className={`plinko-bet-history-item d-flex align-items-center justify-content-center fw-bold small ${color}`} style={{ animationDelay: `${index * 60}ms` }}>
                            {data?.coefficient}x
                          </li>
                        );
                      }
                      return (
                        <li
                          key={data.betKey}
                          className={`plinko-bet-history-item d-flex align-items-center justify-content-center fw-bold small ${color}`}
                        >
                          {data?.coefficient}x
                        </li>
                      );
                    })}
                </ul>
              </div>

            </div>
            <ChangeSeedModal />
            <div className='live-bets-data-table mt-3 mb-3'>
              <div className='d-flex flex-wrap justify-content-between align-items-center d-none'>
                <div className='d-flex align-items-center'>
                  <label className='me-3 fw-bold fs-5 text-white'>{t('LIVE_BETS')}</label>
                  <SelectBox
                    dropdownOption={LIVE_BETS_DROPDOWN_OPTIONS}
                    selectedValue={selectedAutoBetValue}
                    setSelectedValue={setSelectedAutoBetValue}
                    setValue={setLiveBetCount}
                    disabled={false}
                    className='toggle-md-icon-none w-auto form-plinko-select rounded-10'
                  />
                </div>
                <Button className='btn-plinko-primary btn-mobile-game-settings d-lg-none text-white fw-bold rounded-10' onClick={() => setGameSettings(!gameSettings)}>{t('GAME_SETTINGS')}</Button>
              </div>
              <hr className='hr-line mb-2 mt-4' />
              <div className='table-responsive'>
                <table className='table default-table custom-games-table text-white mb-0'>
                  <thead />
                  <tbody>
                    {/* table row */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <GameFooter
            liveStats={liveStats}
            resetStats={resetStats}
            isKeyBindEnabled={isKeyBindEnabled}
            setIsHotkeysModal={setIsHotkeysModal}
            handleFairnessModal={handleFairnessModal}
            isSetting={isSetting}
            setIsSetting={setIsSetting}
            demoMode={demoMode}
            gameSound={gameSound}
            gameMusic={gameMusic}
          />
        </div>
        {(isSessionExpired || isOffline) && <TimeOutModal isOpen={isSessionExpired || isOffline} />}

        {/* <GameFooter /> */}
        {isHotkeysModal &&
          <HotkeysModal
            isOpenModal={isHotkeysModal}
            setIsHotkeysModal={setIsHotkeysModal}
            className='hotkeys-modal'
            isKeyBindEnabled={isKeyBindEnabled}
            setIsKeyBindEnabled={setIsKeyBindEnabled}
          />}
        {openFairnessModal && (
          <OneToOneGameFairnessModal
            t={t}
            roundBetHistory={roundBetHistory}
            roundBetHistory={myBetsData?.rows[0]}
            handleModal={handleFairnessModal}
            open={openFairnessModal}
            gameId={DEFAULT_GAME_ID.PYRAMID_PLINKO}
            resultData={myBetsData?.rows}
          />
        )}
      </div>
    </div>
  )
}

export { isAutoBetActive }
export default PyramidPlinkoGame
